import { Event } from "../../api.types"
import { useDateFormat } from "../../hooks/useDateFormat"
import { useTranslation } from "react-i18next";
import { Deadline } from "./Deadline";
import { EventStatus } from "../EventView";
import { Divider } from "antd"
import { Cond } from "../Cond";

export function EventHeader(props: { event: Event }): (JSX.Element | null) {
    const formatDate = useDateFormat()
    const { t } = useTranslation()

    const {event} = props;

    let stage = ""
    switch (event.status) {
        case EventStatus.Propositions:
            stage = (t("Propositions"))
            break
        case EventStatus.PropositionsWait:
            stage = (t("Propositions")) + " - " + t('Wait for others');
            break;
        case EventStatus.Preferences:
            stage = (t("Preferences"))
            break
        case EventStatus.PreferencesWait:
            stage = (t("Preferences")) + " - " + t('Wait for others');
            break;
        case EventStatus.Done:
            stage = t("Results");

    }

    return <>
        {event.name ? <h1>{event.name}</h1> : undefined}
        {event.eventDate ? (<div style={{ fontWeight: "bold", fontSize: "1.1em" }}>Termin: {formatDate(event.eventDate)}</div>) : undefined}
        {event.name || event.eventDate ? <hr style={{ backgroundColor: "#eee", border: "0.5px #eee solid" }} /> : undefined}
        <h2>{stage}</h2>
        <Cond show={event.status === EventStatus.PropositionsWait || event.status === EventStatus.PreferencesWait}>
            <h3>
                {"Status: "}
                {
                    event.participantCountLimit ?
                        t('votedNOutOfM', { count: event.entryCount, total: event.participantCountLimit }) :
                        t('votedN', { count: event.entryCount })
                }
            </h3>
        </Cond>
        <Deadline event={event} />

        <Divider />
    </>
}
